<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="850"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Generate invoice</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column mx-5 py-7"
        style="z-index: 33332 !important"
      >
        <div class="min-h-75px">
          <v-autocomplete
            v-model="formData.contract_id"
            :items="$store.getters.getINVOICESTableStructure?.contracts"
            item-text="text"
            item-value="index"
            label="Contract"
            dense
            outlined
            clearable
            :error-messages="contract_idErrors"
            @blur="$v.formData.contract_id.$touch()"
          />
        </div>

        <div class="min-h-75px">
          <DateRangePicker
            @on-submit="getDateRange"
            :errorMessages="date_rangeErrors"
            :onBlur="() => $v.formData.date_range.$touch()"
          />
        </div>

        <!--begin::Actions-->
        <div
          class="my-4 min-h-75px d-flex flex-grow-1 align-end justify-center"
        >
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetFormData"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import DateRangePicker from "@/own/components/finance/invoices/DateRangePicker.vue";
import Swal from "sweetalert2";

export default {
  name: "Generate",
  props: ["updateTableContent", "pageLoader"],
  components: { DateRangePicker },
  mixins: [validationMixin],
  validations: {
    formData: {
      contract_id: { required },
      date_range: { required },
    },
  },
  data: () => ({
    dialog: false,
    date: { startDate: null, endDate: null },
    inputValue: null,
    menu2: false,
    formData: {
      contract_id: null,
      date_range: null,
    },
  }),
  methods: {
    getDateRange(val) {
      this.formData.date_range = val;
    },
    toggleModal() {
      this.resetFormData();
      // else {
      //   this.loadDataFromServer();
      // }
      this.dialog = !this.dialog;
    },
    handleFormValidation(fieldName) {
      const errors = [];
      if (!this.$v.formData[fieldName].$dirty) return errors;
      if ("required" in this.$v.formData[fieldName]) {
        !this.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    submitForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.pageLoader(true);
      ApiService.post(`/cod/invoices/generate_invoice`, {
        ...this.formData,
      })
        .then(() => {
          Swal.fire("Success!", "Invoice generated successfully!", "success");
          this.toggleModal();
          this.updateTableContent();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetFormData() {
      this.formData = { contract_id: null, date_range: null };
    },
  },
  computed: {
    contract_idErrors: function () {
      return this.handleFormValidation("contract_id");
    },
    date_rangeErrors: function () {
      return this.handleFormValidation("date_range");
    },
  },
};
</script>

<style>
.v-radio label {
  margin-bottom: 0;
}
</style>
